<template>
    <v-row class="mx-1">
        <view-form v-model="viewFormDialog"></view-form>
        <attach-form v-model="showAttachFormDialog" :formId="formId" @cancelAttach="formId = undefined"></attach-form>

        <v-col cols="12" class="d-flex justify-space-between flex-wrap align-end pt-0">
            <v-text-field
                class="mr-4"
                color="kbDarkBlueText"
                v-model="search"
                append-icon="search"
                :placeholder="$t('general.search')"
                single-line
                hide-details
                clearable>
            </v-text-field>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-btn :disabled="companyBlocked"
                               color="mainButtons"
                               dark
                               @click="$router.push({name: 'Nuevo Formulario', params: { appid: $route.params.appid }})">
                            {{$t('general.addNew')}}
                        </v-btn>
                    </div>
                </template>
                <span>{{ companyBlocked? $t('general.needToRefreshBeforeCreateForms') : $t('general.createForm')}}</span>
            </v-tooltip>
        </v-col>

        <v-col cols="12" class="text-h6 pb-0">
            <v-data-table :headers="headers"
                          fixed-header
                          :height="dataTableHeight"
                          :items="forms"
                          class="elevation-2"
                          :loading="loadingForms"
                          :options.sync="options"
                          :footer-props="{
                            'items-per-page-text': $t('general.formsPerPage'),
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalForms">
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="font-weight-bold">{{ item.name }}</td>
                        <td>{{ item.code }}</td>
                        <td>{{ item.description }}</td>
                        <td>
                          <div class="d-flex justify-center align-center">
                            <v-btn icon @click="showForm(item)" color="kbDarkBlueText">
                              <v-icon>remove_red_eye</v-icon>
                            </v-btn>

                            <v-btn icon
                                   @click="$router.push({name: 'Editar Formulario', params: { appid: $route.params.appid, formid: item._id }})"
                                   color="kbDarkBlueText">
                              <v-icon>
                                edit
                              </v-icon>
                            </v-btn>

                            <v-btn icon @click="showAttachForm(item._id)" color="kbDarkBlueText">
                              <v-icon>attachment</v-icon>
                            </v-btn>
                          </div>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingForms">
                            {{$t('general.loadingForms')}}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{$t('general.noFormsRegistered')}}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import AttachForm from '@/pages/App/Forms/dialogs/AttachForm.vue'
import ViewForm from '@/pages/App/Forms/dialogs/ViewForm.vue'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
export default {
  components: { AttachForm, ViewForm },
  created () {
    this.$store.dispatch('getRoles')
  },
  computed: {
    ...mapState({
      loadingForms: state => state.forms.loadingForms,
      paginationForms: state => state.forms.paginationForms,
      selectedApp: state => state.apps.selectedApp,
      totalForms: state => state.forms.totalForms,
      forms: state => state.forms.forms
    }),
    search: {
      get () {
        return this.$store.state.forms.search
      },
      set (value) {
        this.$store.commit('SET_SEARCH_FORMS', value)
      }
    },
    companyBlocked () {
      return this.$store.getters.companyPaymentState === 'block' && !this.$store.getters.companyIsMonthlyBilling
    },
    headers () {
      return [
        { text: this.$t('general.formName'), value: 'name' },
        { text: this.$t('general.code'), value: 'code' },
        { text: this.$t('general.description'), value: 'description' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: 'actions' }
      ]
    }
  },
  data () {
    return {
      formId: '',
      options: {},
      selectedForm: null,
      showAttachFormDialog: false,
      viewFormDialog: false
    }
  },
  methods: {
    showAttachForm (formId) {
      this.formId = formId
      this.showAttachFormDialog = true
    },
    showForm (form) {
      this.$store.dispatch('getForm', form._id)
      this.viewFormDialog = true
    },
    getForms () {
      this.$store.commit('SET_PAGINATION_FORMS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getForms')
    }
  },
  mixins: [ModuleTableHeight],
  watch: {
    options: {
      handler () {
        this.getForms()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.options.page = 1
      this.getForms()
    },
    selectedApp () {
      this.$store.dispatch('getForms')
    }
  }
}
</script>
